"use client";
import React, { createContext, useState, useEffect } from "react";
import api from "../api";
import ToastMessage from "../components/ToastMessage"; // Toast notification component

export const QuoteContext = createContext();

export const QuoteProvider = ({ children }) => {
  const [quoteItems, setQuoteItems] = useState([]);
  const [isQuoteBarOpen, setIsQuoteBarOpen] = useState(false);
  const [toast, setToast] = useState(null);

  // --- Toast handler ---
  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000); // better UX: auto-hide after 3s
  };

  // --- Fetch quote cart on mount ---
  useEffect(() => {
   const fetchQuotes = async () => {
      try {
        const res = await api.get("/api/quotes/cart");
        const items = res.data.cartItems || [];
        setQuoteItems(items);
      } catch (err) {
        console.error("Failed to fetch quote items", err);
        setQuoteItems([]); // ✅ always keep it an array
      }
    };
    fetchQuotes();
  }, []);

  // --- Add product to quote ---
  const addToQuote = async (formData) => {
    try {
      const res = await api.post("/api/quotes/add-item", formData);

      if (res.data.status === "success") {
        const items = res.data.cartItems || [];
        setQuoteItems(items);
        showToast(res.data.message || "Item added successfully", "success");
      } else {
        showToast(res.data.message || "Failed to add item", "error");
      }
    } catch (err) {
      console.error("Add to quote failed", err);
      showToast("Failed to add item", "error");
    }
  };
  // -- updTate quote ---
  const updateQuoteItems = (items) => {
  setQuoteItems(items);
};
  // --- Toggle quote bar ---
  const toggleQuoteBar = () => setIsQuoteBarOpen((prev) => !prev);

  return (
    <QuoteContext.Provider
      value={{
        quoteItems,
        addToQuote,
        isQuoteBarOpen,
        updateQuoteItems,
        toggleQuoteBar,
      }}
    >
      {children}
      {toast && <ToastMessage message={toast.message} type={toast.type} />}
    </QuoteContext.Provider>
  );
};
